const SignUpCategory = 'sign_up';
const SignUpCompletedAction = 'sign_up';

export { SignUpCategory, SignUpCompletedAction };
